import React from 'react';
import * as S from './statement-code-key.styles';

export interface StatementCodeKeyItem {
    code: string;
    title: string;
    description: string;
    tone: 'neutral' | 'warning';
}

export const StatementCodeKey: React.FC<{ items: StatementCodeKeyItem[] }> = ({ items }) => {
    if (items.length === 0) {
        return null;
    }

    return (
        <S.CodeKeyCard>
            <S.CodeKeyTitle>Adjustment & responsibility code key</S.CodeKeyTitle>
            <S.CodeKeyGrid>
                {items.map(item => (
                    <S.CodeKeyItem key={item.code}>
                        <S.CodeBadge tone={item.tone}>{item.code}</S.CodeBadge>
                        <S.CodeKeyCopy>
                            <S.CodeKeyItemTitle>{item.title}</S.CodeKeyItemTitle>
                            <S.CodeKeyItemDesc>{item.description}</S.CodeKeyItemDesc>
                        </S.CodeKeyCopy>
                    </S.CodeKeyItem>
                ))}
            </S.CodeKeyGrid>
        </S.CodeKeyCard>
    );
};
